<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomSelect
          :options="presetsOptions"
          label="Свойство"
          :required="true"
          optionValueKey="prop_id"
          optionLabelKey="prop_name"
          :fullWidth="true"
          :value="this.formData.prop_id"
          @change="(value) => onChange('prop_id', value)"
        />
        <CustomSelect
          :options="propertyDictionaryOptions"
          label="Свойство"
          optionValueKey="prop_dict_id"
          optionLabelKey="prop_value"
          :required="true"
          :fullWidth="true"
          :value="this.formData.prop_dict_id"
          @change="(value) => onChange('prop_dict_id', value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";
import CustomUploader from "@/components/form/CustomUploader";

import {
  getPropertyValue,
  readPropertyDictionary,
} from "@/views/Materials/MaterialsList/MaterialEdit/services";

export default {
  name: "materials-constructor-upd-prop",
  components: { CustomModalFooter, CustomSelect, CustomInput, CustomUploader },
  props: ["data"],
  data() {
    return {
      loading: false,
      btnLoading: false,
      formData: {
        material_id: this.data?.body.material_id || "",
        material_prop_value_id: this.data?.body.material_prop_value_id || "",
        prop_id: this.data?.body.prop_id || "",
        prop_dict_id: this.data?.body.prop_dict_id || "",
      },
      presetsOptions: this.data?.presetsOptions || [],
      propertyDictionaryOptions: [],
    };
  },
  watch: {
    "formData.prop_id"(newValue) {
      if (newValue) {
        this.fetchPropertyDictionary();
      }
    },
  },
  methods: {
    async getData() {
      if (this.data?.body.material_prop_value_id) {
        const res = await getPropertyValue(
          this.data?.body.material_prop_value_id
        );
        this.formData = res[0];
      }
    },
    onChange(key, value) {
      this.formData[key] = value;
      if (key === "prop_id") {
        this.formData.prop_dict_id = "";
      }
    },
    async onSubmit() {
      this.btnLoading = true;
      await this.data?.onSubmit({
        material_id: this.formData.material_id,
        material_prop_value_id: this.formData.material_prop_value_id,
        prop_dict_id: this.formData.prop_dict_id,
      });
      this.btnLoading = false;
    },
    async fetchPropertyDictionary() {
      if (!this.formData.prop_id) return;
      const body = {
        material_id: this.formData.material_id,
        prop_id: this.formData.prop_id,
      };
      this.propertyDictionaryOptions = await readPropertyDictionary(body);
    },
  },
  async mounted() {
    this.getData();
    this.fetchPropertyDictionary();
  },
};
</script>
